import React, { useState } from 'react';
import { Form, Select } from 'antd';
import { useTranslation } from 'react-i18next';

interface MacroregionFieldProps {
  options: Array<{ label: string; value: string }>;
  loading: boolean;
  disabled?: boolean;
}

export function MacroregionField({
  options,
  loading,
  disabled = false,
}: MacroregionFieldProps) {
  const { t } = useTranslation('create-alarm-step');
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState<string[]>([]);

  return (
    <Form.Item
      name="macroregioes"
      label={t('create-alarm-step:stepOne.createAlarmMacroregionField')}
      rules={[
        {
          required: true,
          message: t(
            'create-alarm-step:stepOne.createAlarmMacroregionRequired',
          ),
        },
      ]}
    >
      <Select
        mode="multiple"
        allowClear
        options={options}
        value={value}
        open={open}
        loading={loading}
        disabled={loading || disabled}
        onDropdownVisibleChange={visible => setOpen(visible)}
        onChange={vals => setValue(vals)}
        onSelect={val => {
          setValue([...value, val]);
          setOpen(false);
        }}
      />
    </Form.Item>
  );
}
